<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-body">
          <slot name="body">
            <div class="modal-content">
              <iframe
                v-if="type === 'services'"
                src="/tos/services.html"
              ></iframe>
              <iframe
                v-if="type === 'privacy'"
                src="/tos/privacy.html"
              ></iframe>
              <iframe
                v-if="type === 'marketing'"
                src="/tos/marketing.html"
              ></iframe>
              <div class="btn-wrap">
                <button @click="closeModal">닫기</button>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="./layout.css" scoped></style>

<script>
/* eslint-disable */
export default {
  name: "noticeTemplate",
  props: ["type"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
  computed: {},
  mounted() {
    document.body.style.overflow = "hidden";
  },
  destroyed() {
    document.body.style.overflow = "unset";
  },
};

export const noticeConfig = () => {};
</script>
<style scoped>
.modal-content {
  line-height: 2;
}
</style>
